import { AsyncState, Updater } from 'widgets-for-react'
import { Set } from 'immutable'
import { loadSeasonalCalendarData } from './seasonalCalendarApi'

export type SeasonalCalendarState = {
  seasonalCalendarDataState: AsyncState<SeasonalCalendarData>
  expandedMainCategories: Set<string>
  filterOnMonth?: Month
  renderUpTo: number
}

export type SeasonalCalendarData = {
  mainCategoryTitle: string
  mainCategoryName: string
  subcategories: {
    subcategoryName: string
    entries: {
      characteristic: string
      ingredient: string
      variant: string
      MonthlyAvailabilities: number[]
    }[]
  }[]
}[]

export const months = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11] as const
export type Month = typeof months[number]

export const initialSeasonalCalendarState: SeasonalCalendarState = {
  seasonalCalendarDataState: loadSeasonalCalendarData,
  expandedMainCategories: Set<string>(),
  renderUpTo: 1,
}

export const seasonalCalendarStateUpdaters = {
  updateSeasonalCalendarDataState:
    (updater: Updater<AsyncState<SeasonalCalendarData>>) =>
    (currentState: SeasonalCalendarState): SeasonalCalendarState => ({
      ...currentState,
      seasonalCalendarDataState: updater(
        currentState.seasonalCalendarDataState
      ),
    }),
  updateExpandedMainCategories:
    (updated: Set<string>) =>
    (currentState: SeasonalCalendarState): SeasonalCalendarState => ({
      ...currentState,
      expandedMainCategories: updated,
    }),
  updateFilterOnMonth:
    (update?: Month) =>
    (currentState: SeasonalCalendarState): SeasonalCalendarState => ({
      ...currentState,
      filterOnMonth: update,
    }),
  updateRenderUpTo:
    (updater: Updater<number>) =>
    (currentState: SeasonalCalendarState): SeasonalCalendarState => ({
      ...currentState,
      renderUpTo: updater(currentState.renderUpTo),
    }),
}
